import React from "react";
import { Divider, DividerProps } from "antd";

interface ViewProps extends DividerProps {
  label?: string;
}

export default function View({ label = "", ...props }: ViewProps) {
  return <Divider {...props}>{label}</Divider>;
}
